import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

interface Address {
  co?: string;
  country?: string;
  dist?: string;
  house?: string;
  lm?: string;
  loc?: string;
  pc?: string;
  po?: string;
  state?: string;
  street?: string;
  subdist?: string;
  vtc?: string;
}

@Component({
  selector: 'app-kycdisplay',
  templateUrl: './kycdisplay.component.html',
  styleUrls: ['./kycdisplay.component.css']
})
export class KycdisplayComponent implements OnInit {
  
  dob1: string = '';
  gender1: string = '';
  name1: string = '';
  address: Address = {}; // Initialized as an empty object
  photoBase64: string = '';
  imageSrc: string = '';
  lastData: string | null = null; // Nullable, as sessionStorage might return null

  constructor(private http: HttpClient, private router: Router, private dialog: MatDialog) {}

  ngOnInit() {
    // Retrieve the session storage value
    this.lastData = sessionStorage.getItem('lastData');

    if (this.lastData) {
      console.log('Decoded KYC Response:', this.lastData);

      try {
        // Initialize XML parser
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(this.lastData, 'text/xml');

        // Extracting data from UidData tag
        const uidData = xmlDoc.getElementsByTagName('UidData')[0];
        if (uidData) {
          // Extract data from <Poi> tag
          const poi = uidData.getElementsByTagName('Poi')[0];
          if (poi) {
            this.dob1 = poi.getAttribute('dob') || '';
            this.gender1 = poi.getAttribute('gender') || '';
            this.name1 = poi.getAttribute('name') || '';
          }

          // Extract address data from <Poa> tag
          const poa = uidData.getElementsByTagName('Poa')[0];
          if (poa) {
            this.address = {
              co: poa.getAttribute('co') || '',
              country: poa.getAttribute('country') || '',
              dist: poa.getAttribute('dist') || '',
              house: poa.getAttribute('house') || '',
              lm: poa.getAttribute('lm') || '',
              loc: poa.getAttribute('loc') || '',
              pc: poa.getAttribute('pc') || '',
              po: poa.getAttribute('po') || '',
              state: poa.getAttribute('state') || '',
              street: poa.getAttribute('street') || '',
              subdist: poa.getAttribute('subdist') || '',
              vtc: poa.getAttribute('vtc') || ''
            };
          }

          // Extract photo from <Pht> tag
          const phtElement = uidData.getElementsByTagName('Pht')[0];
          const pht = phtElement ? phtElement.textContent : '';
          this.photoBase64 = pht || '';
          this.imageSrc = 'data:image/jpeg;base64,' + this.photoBase64;
        }
      } catch (error) {
        console.error('Error parsing KYC data:', error);
      }
    } else {
      console.error('No KYC data found in session storage.');
    }
  }

  closePage(){
    const url = `https://secureid.jiolabs.com/secureid/product/#/login`;
    window.location.href = encodeURI(url);
  }
}
